import src from "IMAGE";
export default { src, width: 131, height: 156, blurWidth: 0, blurHeight: 0};
